module.exports = "/_next/static/images/game-1-intro-landing-bg-top-3e461f5171d257991288cd1b2bd41a4d.png";